module.exports = __webpack_public_path__ + "media/customizations/womensleadership/back-b13fb520b18701226277f7ad365160dd.jpg";